/** Tasks 7.13–7.15 registrations (the File Shares tree extension, the files-mode transfer toolbar) — side effects only. */
import { registerFileToolbarExtensions } from './fileToolbarExtensions';
import { registerS7StorageTreeExtension } from './tree/shareMenuItems';

registerS7StorageTreeExtension();
registerFileToolbarExtensions();
